import {
  Grid,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Paper,
  makeStyles,
  TableContainer,
  TextField,
  Button,
  InputAdornment,
} from "@material-ui/core";
import { useTable } from "react-table";
import React from "react";
import { Controller, useFieldArray } from "react-hook-form";

const useStyles = makeStyles((theme) => ({
  tableCell: {
    paddingTop: 3,
    paddingBottom: 3,
  },
  imgPreview: {
    maxHeight: "30px",
    width: "auto",
  },
  faHeader: {
    fontWeight: "normal",
    fontSize: "13px",
    lineHeight: "15px",
    color: "#3C3C3C",
    "& .externalLink": {
      color: "#999999",
      "& a": {
        color: "#306F9D",
        textDecoration: "none",
      },
    },
  },
}));

const defaultValue = {
  id: "",
  localizations: {
    en: { name: "", url: "" },
    tc: { name: "", url: "" },
  },
};

function FooterSocialNetworkSection(props) {
  const classes = useStyles();
  const { control, activeLang, disabled } = props;
  const { fields, append } = useFieldArray(
    {
      control,
      name: "social",
    }
  );
  const columns = React.useMemo(
    () => [
      {
        Header: "No.",
        accessor: "id",
        Cell: ({ row }) => {
          return <div>{row.index + 1}</div>;
        },
      },
      {
        // Header: "Name",
        accessor: `localizations.${activeLang}.name`,
        Header: () => {
          return (
            <div className={classes.faHeader}>
              <div>Font Awesome Icon name </div>
              <div className="externalLink">
                Find the name here:{" "}
                <a
                  href="http://fontawesome.io/icons"
                  target="_blank"
                  rel="noreferrer"
                >
                  http://fontawesome.io/icons
                </a>
              </div>
            </div>
          );
        },
        Cell: ({ row }) => {
          return (
            <Grid container alignItems="center" xs={12}>
              <Controller
                defaultValue={row.original.localizations[`${activeLang}`].name}
                name={`social.${row.index}.localizations.${activeLang}.name`}
                control={control}
                render={({ field, fieldState: { error } }) => (
                  <TextField
                    variant="outlined"
                    margin="dense"
                    className={classes.textInput}
                    fullWidth
                    {...field}
                    error={!!error}
                    helperText={error ? error.message : ""}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">fa-</InputAdornment>
                      ),
                    }}
                  />
                )}
              />
            </Grid>
          );
        },
      },
      {
        Header: "Url",
        accessor: `localizations.${activeLang}.url`,
        Cell: ({ row, ...rest }) => {
          return (
            <Controller
              defaultValue={row.original.localizations[`${activeLang}`].url}
              name={`social.${row.index}.localizations.${activeLang}.url`}
              control={control}
              render={({ field, fieldState: { error } }) => (
                <TextField
                  variant="outlined"
                  margin="dense"
                  className={classes.textInput}
                  fullWidth
                  {...field}
                  error={!!error}
                  helperText={error ? error.message : ""}
                />
              )}
            />
          );
        },
      },
    ],
    []
  );

  const { getTableProps, headerGroups, rows, prepareRow } = useTable({
    columns,
    data: fields,
  });
  return (
    <>
      <TableContainer
        component={(props) => (
          <Paper elevation={0} variant="outlined" {...props} />
        )}
      >
        <Table {...getTableProps()} size="small">
          <TableHead>
            {headerGroups.map((headerGroup) => (
              <TableRow {...headerGroup.getHeaderGroupProps()}>
                {headerGroup.headers.map((column) => (
                  <TableCell
                    {...column.getHeaderProps()}
                    className={classes.tableCell}
                  >
                    {column.render("Header")}
                  </TableCell>
                ))}
              </TableRow>
            ))}
          </TableHead>
          <TableBody>
            {rows.map((row, i) => {
              prepareRow(row);
              return (
                <TableRow {...row.getRowProps()}>
                  {row.cells.map((cell) => {
                    return (
                      <TableCell
                        {...cell.getCellProps()}
                        className={classes.tableCell}
                      >
                        {cell.render("Cell")}
                      </TableCell>
                    );
                  })}
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
      <Grid container xs={12} justify="flex-end">
        {disabled || (
          <Button
            onClick={() => append(defaultValue)}
            variant="contained"
            color="primary"
          >
            Add New Column
          </Button>
        )}
      </Grid>
    </>
  );
}

export default FooterSocialNetworkSection;
